import { z } from '@hono/zod-openapi'
import { clientsTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

// ---------- Backend Schemas ----------
export const zSelectClient = createSelectSchema(clientsTable)

export const zInsertClient = createInsertSchema(clientsTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})

export const zUpdateClient = zInsertClient.partial()

export const zQueryClients = zInsertClient
    .extend({
        id: z.string(),
        ids: z.string().array(),
        status: z.enum(['active', 'suspended']).optional(),
    })
    .extend(zCommonQuery.shape)
    .partial()

// ---------- Backend Types ----------
export type SelectClient = z.infer<typeof zSelectClient>
export type InsertClient = z.infer<typeof zInsertClient>
export type UpdateClient = z.infer<typeof zUpdateClient>
export type QueryClients = z.infer<typeof zQueryClients>
export type ColumnsOfClientsTable = keyof typeof clientsTable._.columns
